import * as React from 'react';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { observer } from 'mobx-react-lite';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';

const styles = require('./CLPSubjectHeaderLabel.scss');

export interface CLPSubjectHeaderLabelProps {
    subjectHeaderLabel: CLPLabel;
}

export default observer(function CLPSubjectHeaderLabel(props: CLPSubjectHeaderLabelProps) {
    const { subjectHeaderLabel } = props;

    return subjectHeaderLabel ? (
        <TooltipHost content={subjectHeaderLabel.tooltip} hostClassName={styles.subjectLabel}>
            <span tabIndex={0}>
                <Icon
                    iconName={
                        subjectHeaderLabel.isEncryptingLabel
                            ? ControlIcons.Lock
                            : ControlIcons.MarkAsProtected
                    }
                    className={styles.labelIcon}
                />
                <span className={styles.subjectLabelText}>
                    {subjectHeaderLabel.infobarDisplayText}
                </span>
            </span>
        </TooltipHost>
    ) : null;
});
